export const ALLOWED_IMAGE_UPLOAD_MIME_TYPES = 'image/jpeg,image/png';
export const ARCHIVE = 'ARCHIVE';
export const CREATION_LINK = '/creation/start';
export const LANDING_START_LINK = '/landing-pages/landing-page/new/start';
export const CREATION_TYPES = {
    KWB: 'kwb',
    LANDING_PAGE: 'landing-page',
    REBATE: 'rebate',
    SYNDICATED: 'syndicated',
};
export const DUPLICATE = 'DUPLICATE';
export const END = 'END';
export const FEATURE = 'FEATURE';
export const MAX_MEDIA_PER_CAMPAIGN = 6;
export const MONEY_OFF = 'Money off';
export const PAUSE = 'PAUSE';
export const PERCENT_OFF = 'Percentage off';
export const PROMOTION_TYPE = {
    MULTI_USE: 'MULTI_CODE',
    REBATE: 'REBATE',
    SINGLE_USE: 'SINGLE_USE',
    URL: 'URL',
};
export const START = 'START';
export const STATE = {
    ARCHIVED: 'ARCHIVED',
    DRAFT: 'DRAFT',
    PAUSED: 'PAUSED',
    PUBLISHED: 'PUBLISHED',
    STOPPED: 'STOPPED',
};
export const STATUS = {
    ARCHIVED: 'ARCHIVED',
    DRAFT: 'DRAFT',
    ENDED: 'ENDED',
    LIVE: 'LIVE',
    PAUSED: 'PAUSED',
    PENDING: 'PENDING',
};
export const STEPS = {
    ADDONS: 'addons',
    CONFIRMATION: 'confirmation',
    EMAIL: 'email',
    KEYWORD_BOOST: 'keyword-boost',
    LANDING: 'landing',
    OFFER: 'offer',
    PREVIEW: 'preview',
    PRODUCT: 'product',
    START: 'start',
};
export const TYPES = {
    LANDING_PAGE: 'LANDING-PAGE',
    REBATE: 'REBATE',
    STANDARD: 'STANDARD',
    SYNDICATION: 'SYNDICATION',
};
export const VIDEO = 'video';



// WEBPACK FOOTER //
// ./src/constants/campaigns.js